// extracted by mini-css-extract-plugin
export var aggregationCell = "_2s-t";
export var aggregationRow = "_2s-s";
export var borderlessSpinnerContainer = "_2s-3";
export var cardLayout = "_2s-6";
export var cardLayoutNoFooter = "_2s-a";
export var cardLayoutPageControl = "_2s-9";
export var cardLayoutWithFooter = "_2s-8";
export var closeIcon = "_2s-l";
export var columnHeaderSurface = "_2s-d";
export var columnHeaderSurfaceDragOverlay = "_2s-11";
export var columnHeaderSurfaceResizing = "_2s-y";
export var contextMenuAnchor = "_2s-1";
export var draggableColumnHeader = "_2s-z";
export var draggableColumnHeaderOverlay = "_2s-10";
export var expandIcon = "_2s-m";
export var expanded = "_2s-n";
export var filterBackIcon = "_2s-g";
export var filterButtonAnchor = "_2s-f";
export var filterDropdown = "_2s-o";
export var filterDropdownDivider = "_2s-j";
export var filterDropdownHeader = "_2s-r";
export var filterDropdownItem = "_2s-q";
export var filterDropdownModal = "_2s-p _2s-o";
export var filterItem = "_2s-e";
export var normalCellWithAdjustableBorder = "_2s-k";
export var pinButtonContainer = "_2s-u";
export var pinIcon = "_2s-v";
export var pinIconActive = "_2s-w";
export var spinner = "_2s-0";
export var spinnerContainer = "_2s-2";
export var subFilterArrowIcon = "_2s-h";
export var tableContainer = "_2s-4";
export var tableContentDraggingColumns = "_2s-c";
export var tableContentInner = "_2s-7";
export var tableContentInnerFill = "_2s-b";
export var tableContentWrapper = "_2s-5";
export var toolbarEnd = "_2s-i";
export var viewButtonContainer = "_2s-x";